import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

import warningTriangle from '@mui/icons-material/WarningAmber';
import notification from '@mui/icons-material/NotificationsNoneRounded';
import helpOutlineIcon from '@mui/icons-material/HelpOutline';
import infoRounded from '@mui/icons-material/InfoRounded';
import menuBookRounded from '@mui/icons-material/MenuBookRounded';
import infoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import receiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';

const exclamationTriangleGray = createSvgIcon(
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3230_104026)">
      <path d="M14.1459 2.27472C14.0162 2.04002 13.826 1.84437 13.5951 1.70812C13.3642 1.57186 13.101 1.5 12.8329 1.5C12.5647 1.5 12.3015 1.57186 12.0706 1.70812C11.8397 1.84437 11.6495 2.04002 11.5199 2.27472L1.76985 20.2747C1.64377 20.5031 1.57942 20.7604 1.58316 21.0212C1.5869 21.282 1.65859 21.5374 1.79117 21.762C1.92375 21.9867 2.11261 22.1729 2.33914 22.3023C2.56566 22.4316 2.822 22.4997 3.08286 22.4997H22.5829C22.8437 22.4997 23.1001 22.4316 23.3266 22.3023C23.5531 22.1729 23.742 21.9867 23.8746 21.762C24.0071 21.5374 24.0788 21.282 24.0826 21.0212C24.0863 20.7604 24.0219 20.5031 23.8959 20.2747L14.1459 2.27472Z" stroke="gray" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 15V8.25" stroke="gray" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 18.75C12.6259 18.75 12.458 18.5821 12.458 18.375C12.458 18.1679 12.6259 18 12.833 18" stroke="gray" strokeWidth="1.5" />
      <path d="M12.833 18.75C13.0401 18.75 13.208 18.5821 13.208 18.375C13.208 18.1679 13.0401 18 12.833 18" stroke="gray" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_3230_104026">
        <rect width="24" height="24" fill="white" transform="translate(0.833008)" />
      </clipPath>
    </defs>
  </svg>,
  'exclamationTriangleGray',
);

const exclamationTriangleBlue = createSvgIcon(
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3230_104026)">
      <path d="M14.1459 2.27472C14.0162 2.04002 13.826 1.84437 13.5951 1.70812C13.3642 1.57186 13.101 1.5 12.8329 1.5C12.5647 1.5 12.3015 1.57186 12.0706 1.70812C11.8397 1.84437 11.6495 2.04002 11.5199 2.27472L1.76985 20.2747C1.64377 20.5031 1.57942 20.7604 1.58316 21.0212C1.5869 21.282 1.65859 21.5374 1.79117 21.762C1.92375 21.9867 2.11261 22.1729 2.33914 22.3023C2.56566 22.4316 2.822 22.4997 3.08286 22.4997H22.5829C22.8437 22.4997 23.1001 22.4316 23.3266 22.3023C23.5531 22.1729 23.742 21.9867 23.8746 21.762C24.0071 21.5374 24.0788 21.282 24.0826 21.0212C24.0863 20.7604 24.0219 20.5031 23.8959 20.2747L14.1459 2.27472Z" stroke="blue" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 15V8.25" stroke="blue" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 18.75C12.6259 18.75 12.458 18.5821 12.458 18.375C12.458 18.1679 12.6259 18 12.833 18" stroke="blue" strokeWidth="1.5" />
      <path d="M12.833 18.75C13.0401 18.75 13.208 18.5821 13.208 18.375C13.208 18.1679 13.0401 18 12.833 18" stroke="blue" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_3230_104026">
        <rect width="24" height="24" fill="white" transform="translate(0.833008)" />
      </clipPath>
    </defs>
  </svg>,
  'exclamationTriangleBlue',
);

const exclamationTriangleRed = createSvgIcon(
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3230_104026)">
      <path d="M14.1459 2.27472C14.0162 2.04002 13.826 1.84437 13.5951 1.70812C13.3642 1.57186 13.101 1.5 12.8329 1.5C12.5647 1.5 12.3015 1.57186 12.0706 1.70812C11.8397 1.84437 11.6495 2.04002 11.5199 2.27472L1.76985 20.2747C1.64377 20.5031 1.57942 20.7604 1.58316 21.0212C1.5869 21.282 1.65859 21.5374 1.79117 21.762C1.92375 21.9867 2.11261 22.1729 2.33914 22.3023C2.56566 22.4316 2.822 22.4997 3.08286 22.4997H22.5829C22.8437 22.4997 23.1001 22.4316 23.3266 22.3023C23.5531 22.1729 23.742 21.9867 23.8746 21.762C24.0071 21.5374 24.0788 21.282 24.0826 21.0212C24.0863 20.7604 24.0219 20.5031 23.8959 20.2747L14.1459 2.27472Z" stroke="red" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 15V8.25" stroke="red" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 18.75C12.6259 18.75 12.458 18.5821 12.458 18.375C12.458 18.1679 12.6259 18 12.833 18" stroke="red" strokeWidth="1.5" />
      <path d="M12.833 18.75C13.0401 18.75 13.208 18.5821 13.208 18.375C13.208 18.1679 13.0401 18 12.833 18" stroke="red" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_3230_104026">
        <rect width="24" height="24" fill="white" transform="translate(0.833008)" />
      </clipPath>
    </defs>
  </svg>,
  'exclamationTriangleRed',
);

export const triangleWarning = createSvgIcon(
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3230_104026)">
      <path d="M14.1459 2.27472C14.0162 2.04002 13.826 1.84437 13.5951 1.70812C13.3642 1.57186 13.101 1.5 12.8329 1.5C12.5647 1.5 12.3015 1.57186 12.0706 1.70812C11.8397 1.84437 11.6495 2.04002 11.5199 2.27472L1.76985 20.2747C1.64377 20.5031 1.57942 20.7604 1.58316 21.0212C1.5869 21.282 1.65859 21.5374 1.79117 21.762C1.92375 21.9867 2.11261 22.1729 2.33914 22.3023C2.56566 22.4316 2.822 22.4997 3.08286 22.4997H22.5829C22.8437 22.4997 23.1001 22.4316 23.3266 22.3023C23.5531 22.1729 23.742 21.9867 23.8746 21.762C24.0071 21.5374 24.0788 21.282 24.0826 21.0212C24.0863 20.7604 24.0219 20.5031 23.8959 20.2747L14.1459 2.27472Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 15V8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 18.75C12.6259 18.75 12.458 18.5821 12.458 18.375C12.458 18.1679 12.6259 18 12.833 18" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12.833 18.75C13.0401 18.75 13.208 18.5821 13.208 18.375C13.208 18.1679 13.0401 18 12.833 18" stroke="currentColor" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_3230_104026">
        <rect width="24" height="24" fill="white" transform="translate(0.833008)" />
      </clipPath>
    </defs>
  </svg>,
  'triangleWarning',
);

const exclamationTriangleBlack = createSvgIcon(
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3230_104026)">
      <path d="M14.1459 2.27472C14.0162 2.04002 13.826 1.84437 13.5951 1.70812C13.3642 1.57186 13.101 1.5 12.8329 1.5C12.5647 1.5 12.3015 1.57186 12.0706 1.70812C11.8397 1.84437 11.6495 2.04002 11.5199 2.27472L1.76985 20.2747C1.64377 20.5031 1.57942 20.7604 1.58316 21.0212C1.5869 21.282 1.65859 21.5374 1.79117 21.762C1.92375 21.9867 2.11261 22.1729 2.33914 22.3023C2.56566 22.4316 2.822 22.4997 3.08286 22.4997H22.5829C22.8437 22.4997 23.1001 22.4316 23.3266 22.3023C23.5531 22.1729 23.742 21.9867 23.8746 21.762C24.0071 21.5374 24.0788 21.282 24.0826 21.0212C24.0863 20.7604 24.0219 20.5031 23.8959 20.2747L14.1459 2.27472Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 15V8.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.833 18.75C12.6259 18.75 12.458 18.5821 12.458 18.375C12.458 18.1679 12.6259 18 12.833 18" stroke="black" strokeWidth="1.5" />
      <path d="M12.833 18.75C13.0401 18.75 13.208 18.5821 13.208 18.375C13.208 18.1679 13.0401 18 12.833 18" stroke="black" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_3230_104026">
        <rect width="24" height="24" fill="white" transform="translate(0.833008)" />
      </clipPath>
    </defs>
  </svg>,
  'exclamationTriangleBlack',
);

export {
  warningTriangle,
  exclamationTriangleGray,
  exclamationTriangleBlue,
  exclamationTriangleRed,
  exclamationTriangleBlack,
  notification,
  helpOutlineIcon,
  infoRounded,
  menuBookRounded,
  infoOutlinedIcon,
  receiptLongOutlined,
};
